import { Navbar, NavDropdown, Nav, Container } from "react-bootstrap";
import { useDispatch } from "react-redux";
import "./NavBar.css";
import actions from "../redux/actions/userActions";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function NavBar() {
  const dispatch = useDispatch();
  const notify = () => {
    toast.info("This functionality exceeded the scope of this project.", {
      position: toast.POSITION.TOP_RIGHT,
    });
  };
  return (
    <>
      <Navbar
        fixed="top"
        variant="dark"
        bg="dark"
        expand="lg"
        className="border-bottom border-secondary py-2"
      >
        <Container fluid>
          <Navbar.Brand className="ps-4 h2 fs-2 text-gray">
            PremiumTeas
          </Navbar.Brand>
          <Nav className="menu-dropdown ms-auto me-3">
            <NavDropdown
              align="end"
              menuVariant="dark"
              title={<i className="bi bi-person-fill fs-3"></i>}
            >
              <NavDropdown.Item onClick={notify} href="#action3">
                MyAccount
              </NavDropdown.Item>
              <NavDropdown.Item onClick={notify} href="/admins">
                Settings
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item
                href="#action5"
                onClick={() => dispatch(actions.logout)}
              >
                Log Out
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
          <Navbar.Toggle
            className="nav-collapse ms-auto me-2 mb-2 border-0 p-3"
            aria-controls="basic-navbar-nav"
            children={
              <i className="bi bi-person-fill fs-3 d-flex align-items-center">
                <i className="bi bi-caret-down-fill arrow pt-2 ms-1"></i>
              </i>
            }
          />
          <div className="nav-collapse w-100">
            <Navbar.Collapse id="basic-navbar-nav" className="py-3 py-lg-0">
              <Nav className="ms-auto my-2 my-lg-0">
                <Nav.Link href="/" className="ms-3 fs-4">
                  <i className="me-2 bi bi-clipboard-data-fill"></i>Dashboard
                </Nav.Link>
                <Nav.Link href="/admins" className="ms-3 fs-4">
                  <i className="me-2 fs-5 bi bi-person-circle"></i>Admins
                </Nav.Link>
                <Nav.Link href="/categories" className="ms-3 fs-4">
                  <i className="me-2 fs-5 bi bi-card-list"></i>Categories
                </Nav.Link>
                <Nav.Link href="/customers" className="ms-3 fs-4">
                  <i className="me-2 fs-5 bi bi-person-workspace"></i>Customers
                </Nav.Link>
                <Nav.Link href="/orders" className="ms-3 fs-4">
                  <i className="me-2 fs-5 bi bi-receipt-cutoff"></i>Orders
                </Nav.Link>
                <Nav.Link href="/products" className="ms-3 fs-4">
                  <i className="me-2 fs-5 bi bi-gift-fill"></i>Products
                </Nav.Link>
                <hr className="bg-white m-0 my-2" />
                <Nav.Link
                  className="ms-3 fs-4"
                  href="#pricing"
                  onClick={() => dispatch(actions.logout)}
                >
                  <i className="bi bi-box-arrow-right me-2" />
                  Log Out
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </div>
        </Container>
      </Navbar>
      <ToastContainer />
    </>
  );
}

export default NavBar;
